<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import Textarea from '@components/Textarea.svelte';
  import UserAjax from '@ajax/user';
  import Track from '@utils/track';
  const dispatch = createEventDispatcher();

  export let createdUser;
  export let mobile = false;
  export let prefilledBio = null;

  let bioInput = prefilledBio;
  let submitButtonLoading = false;

  $: bioInputPresent = bioInput && bioInput.length > 0;
  $: validInformation = bioInputPresent;

  const saveAvailableInformationAndFinish = function () {
    saveAvailableInformation();
    Track.bioEntered({ bio: bioInput });
    dispatch('finished');
  };

  let saveAvailableInformation = function () {
    if (createdUser && bioInputPresent) {
      UserAjax.update(createdUser, { bio: bioInput });
    }
  };

  let handleSkip = function() {
    Track.bioSkipClick();
    dispatch('finished');
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .user-bio-step {
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: calc(100dvh - 114px);

    .navigation-buttons {
      position: absolute;
      top: 46px;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
    }

    .back-btn, .skip-btn {
      font-weight: 500;
      font-size: 14px;
      color: #1A1A1A;
      cursor: pointer;
      border: none;
      padding: 0 !important;
      background: none;

      &:hover {
        color: #3d3d3d;
      }
    }

    .content-container {
      flex: 1;
      max-width: 440px;
      width: 100%;
      margin: 0 auto;
    }

    .button-container {
       max-width: 440px;
       width: 100%;
       margin: 0 auto;
       padding-bottom: 44px;
     }

    .ui-title {
      font-size: 42px;
      line-height: 38px;
      text-align: center;
      font-weight: 800;
      text-transform: uppercase;
      margin-top: 64px;
      margin-bottom: 16px;
      color: #717171;
    }

    .ui-subtitle {
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #7f7f7f;
      margin-bottom: 32px;
    }
  }

  .mobile {
    min-height: calc(100dvh - 60px);

    .ui-title {
      margin-top: 32px;
    }

    .navigation-buttons {
      top: 18px;
    }

    .skip-btn {
      right: 20px;
      top: 18px;
      padding: 0 !important;
    }
  }

  .user-bio-step {
    * :global(.input-container textarea:focus) {
      background-color: $white !important;
    }
  }
</style>

<div class="user-bio-step" class:mobile={mobile}>
  <div class="navigation-buttons">
    <button class="back-btn" on:click={() => dispatch('back')}>Back</button>
    {#if !bioInputPresent}
      <button
        class="skip-btn test-bio-skip-btn"
        on:click={handleSkip}
      >
        Skip
      </button>
    {/if}
  </div>

  <div class="content-container">
    <div class="ui-title national-2-narrow">Bio</div>

    <div class="ui-body">
      <Textarea
        placeholder="Ex: Mom to 2 kids and a dog. I love sharing makeup recs and decor inspiration! Based in NYC."
        autogrow={true}
        bind:value={bioInput}
        rows={3}
      />
    </div>
  </div>
  <div class="button-container">
    <Button
      text="Next"
      loading={submitButtonLoading}
      disabled={!validInformation}
      on:click={saveAvailableInformationAndFinish} />
  </div>
</div>
